import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedMaterialWeightColumn: CalculationColumn = {
    dataIndex: ['calculated', 'materialWeight'],
    title: 'Вес материала',
    width: 80,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => Math.round((r.calculated?.materialWeight || 0) * 10) / 10),
}
